module.exports = __webpack_public_path__ + "img/order-status-panel.31e244a0.webp";